module.exports = __webpack_public_path__ + "static/img/money-06.f0c0d19.png";